import { CreateSerialNumberPayload, PatchSerialNumberPayload } from "./SerialNumberPayload"
import HttpClient from "../helpers/HttpClient"
import SerialNumber, { SerialNumberDto } from "./SerialNumber"
import { isError } from "../helpers/Error"

class SerialNumberService {
    static httpClient: HttpClient<SerialNumber, SerialNumberDto> = new HttpClient<SerialNumber, SerialNumberDto>(SerialNumber)

    static async create(payload: CreateSerialNumberPayload): Promise<SerialNumber> {
        const res = await this.httpClient.post(`/products/${payload.productId}/serial-numbers`, payload)
        if (isError(res)) {
            throw new Error(res.payload.error?.message || res.message)
        }

        return res
    }

    static async patch(payload: PatchSerialNumberPayload): Promise<SerialNumber> {
        const res = await this.httpClient.patch(`/serial-numbers/${payload.id}`, payload)
        if (isError(res)) {
            throw new Error(res.payload.error?.message || res.message)
        }

        return res
    }

}

export default SerialNumberService


// WEBPACK FOOTER //
// ./src/state/serial-number/SerialNumberService.ts